import React from 'react';
import { CheckIcon } from 'lucide-react';
import { audienceItems, timeValueTasks } from '../data/liikunta';
export function Audience() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-19" data-mp="3p26yoigrjttu">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12" data-id="element-20" data-mp="6vsomulm840q">
        <div className="lg:col-span-7" data-id="element-21" data-mp="1v4x87th5l5z">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-22" data-mp="1u39p3v9v67d">
            Kenelle <em className="text-red-700" style={{
            hyphens: 'manual'
          }} data-id="element-23" data-mp="gqsxjlvo9o4l">LIIKUNTA VALMIS™</em> sopii?
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-slate-900/75" data-id="element-24" data-mp="brzrufmmn1ez">Paketti on tehty sinulle, joka:</p>
          <ul className="mt-8 grid gap-x-8 border-t border-slate-900/15 sm:grid-cols-2" data-id="element-25" data-mp="ljlzy33o4kdi">
            {audienceItems.map(item => <li key={item} className="flex gap-3 border-b border-slate-900/10 py-4 leading-snug text-slate-900/80" data-id="element-26" data-mp="zivgx4zp7iij">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-700" strokeWidth={2.5} aria-hidden="true" data-id="element-27" data-mp="uld6tb9y2x8y" />
                {item}
              </li>)}
          </ul>
          <p className="mt-8 font-serif text-xl italic leading-snug text-slate-900/80" data-id="element-28" data-mp="1bbt47bys4yz3">
            Tehty opettajille, jotka haluavat käyttää vähemmän aikaa valmisteluun ja enemmän aikaa oppilaisiin.
          </p>
        </div>
        <aside className="self-start rounded-3xl bg-slate-900 p-8 text-stone-50 sm:p-11 lg:col-span-5" data-id="element-29" data-mp="1kdsme7lj693m">
          <h3 className="font-serif text-3xl leading-tight sm:text-4xl" data-id="element-30" data-mp="1pasvyshl9tzh">Paljonko aikasi on arvoinen?</h3>
          <p className="mt-4 leading-relaxed text-stone-50/75" data-id="element-31" data-mp="1u9m7wgh89cxj">
            Mieti, kuinka monta tuntia käytät joka viikko liikuntatuntien suunnitteluun:
          </p>
          <ul className="mt-5 divide-y divide-white/10 border-y border-white/10" data-id="element-32" data-mp="2418f81qg2rv0">
            {timeValueTasks.map(task => <li key={task} className="py-3 text-[15px] text-stone-50/85" data-id="element-33" data-mp="2833fr40jx17q">
                {task}
              </li>)}
          </ul>
          <p className="mt-6 leading-relaxed text-stone-50/75" data-id="element-34" data-mp="2d1y5yr0uls1v">
            Kuvittele nyt selkeä paketti, joka auttaa sinua kaikessa tässä – koko lukuvuoden.
          </p>
          <p className="mt-4 font-serif text-xl italic leading-snug text-red-300" data-id="element-35" data-mp="8yd7502v58bs">
            Sinun ei tarvitse enää aloittaa tyhjästä.
          </p>
        </aside>
      </div>
    </section>;
}